import { render, staticRenderFns } from "./AddServingSizeForm.vue?vue&type=template&id=57353228&"
import script from "./AddServingSizeForm.vue?vue&type=script&lang=js&"
export * from "./AddServingSizeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports